import { combineReducers } from "redux";
import carbonCalculator from "../ducks/carbon-calculator";

const reducers = {
  carbonCalculator,
};

export default () =>
  combineReducers({
    ...reducers,
  });
